import { useTranslation } from 'react-i18next';

import { useFormat } from '@nucleus-commerce/i18n/react';
import { Badge } from '@nucleus-commerce/ui/components/badge';
import { cn } from '@nucleus-commerce/ui/lib/utils';

import type { BlogPostState } from '../schemas/post-state';

const STYLES: Record<BlogPostState, string> = {
  live: 'bg-success/15 text-success border-transparent dark:bg-success/20',
  scheduled: 'bg-info/15 text-info border-transparent dark:bg-info/20',
  draft: 'border-border text-muted-foreground',
};

export interface PostStateBadgeProps {
  state: BlogPostState;
  /** Shown in the tooltip of a scheduled post. */
  publishedAt?: string | null;
  className?: string;
}

/** Live (published and past its date), Scheduled (published, date ahead) or Draft. */
export function PostStateBadge({ state, publishedAt, className }: PostStateBadgeProps) {
  const { t } = useTranslation('blog');
  const format = useFormat();
  const title =
    state === 'scheduled' && publishedAt
      ? t('state.scheduledFor', { when: format.dateTime(publishedAt) })
      : undefined;
  return (
    <Badge variant="outline" className={cn(STYLES[state], className)} title={title}>
      {t(`state.${state}`)}
    </Badge>
  );
}
